import store from "../redux/store";
let myToken = null;
const getToken = () => {
  if (myToken === null) {
    const state = store.getState();
    const token = state.main.token;
    myToken = token;

    return token;
  } else {
    return myToken;
  }
};
const deleteToken = () => {
  myToken = null;
};

export default getToken;
export { deleteToken };
